import React from 'react';

const DonutChart = ({ 
  segments = [], 
  icon, 
  centerContent,
  width = 80, 
  height = 80,
  onIconClick
}) => {
  return (
    <div className="d-flex justify-content-center pr-3">
      {centerContent ? (
        <div className="sh_empdashdonut-wrapper" style={{ position: 'relative', width: `${width}px`, height: `${height}px` }}>
          <svg 
            id="donutSvg" 
            width={width} 
            height={height}
            viewBox="0 0 136 136" 
            strokeWidth="6"
            style={{ position: 'relative', zIndex: 1 }}
          >
            <circle 
              className="bg" 
              cx="68" 
              cy="68" 
              r="65" 
              stroke="#f2f2f2" 
              fill="none"
            />
            {segments.map((segment, index) => (
              <circle
                key={index}
                className="sh_donutsegment"
                cx="68"
                cy="68"
                r="65"
                stroke={segment.color}
                fill="none"
                strokeDasharray={segment.dashArray}
                strokeDashoffset={segment.dashOffset}
                strokeLinecap="round"
              />
            ))}
          </svg>
          <div className="sh_empdashdonut-center" style={{ 
            position: 'absolute', 
            top: '50%', 
            left: '50%', 
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            pointerEvents: 'none'
          }}>
            <div className="sh_empdashdonut-card" style={{ textAlign: 'center' }}>
              <div className="sh_empdashdonut-title" style={{ fontSize: '12px', fontWeight: '500', color: '#5F6C85', marginBottom: '4px' }}>{centerContent.title}</div>
              <div className="sh_empdashdonut-value" style={{ fontSize: '16px', fontWeight: '700', color: '#1D1917' }}>{centerContent.value}</div>
            </div>
          </div>
        </div>
      ) : (
        <svg 
          id="donutSvg" 
          width={width} 
          height={height}
          viewBox="0 0 136 136" 
          strokeWidth="6"
        >
          <circle 
            className="bg" 
            cx="68" 
            cy="68" 
            r="65" 
            stroke="#f2f2f2" 
            fill="none"
          />
          {segments.map((segment, index) => (
            <circle
              key={index}
              className="sh_donutsegment"
              cx="68"
              cy="68"
              r="65"
              stroke={segment.color}
              fill="none"
              strokeDasharray={segment.dashArray}
              strokeDashoffset={segment.dashOffset}
              strokeLinecap="round"
            />
          ))}
          {icon && (
            <g 
              className="iconGroup" 
              fill="transparent" 
              transform="translate(50 50) scale(1.2)"
              onClick={onIconClick}
              style={{ cursor: onIconClick ? 'pointer' : 'default' }}
            >
              {icon}
            </g>
          )}
        </svg>
      )}
    </div>
  );
};

export default DonutChart;

